module.exports = __webpack_public_path__ + "static/media/stats-chart-2.bdb8196c.svg";